import usePageTitle from "@/hooks/usePageTitle";
import { useParams, useNavigate } from "react-router-dom";
import EditJobPostForm from "@/components/Forms/JobPostForm/EditJobPostForm";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

export default function EditJobPostPage() {
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.manageJobPosts });
  usePageTitle("Facility | Jobs | Edit Job Post");
  const { facilityId, jobPostId } = useParams();
  const navigate = useNavigate();

  if (!facilityId || !jobPostId) {
    return <div>Unable to find job post.</div>;
  }

  const segments = window.location.pathname.split("/");
  const basePath = segments.slice(0, -2).join("/");

  const handleSuccess = (id: string) => {
    navigate(`${basePath}/${id}/details`);
  };

  return <EditJobPostForm jobPostId={jobPostId} onSuccess={handleSuccess} />;
}
